module.exports = __webpack_public_path__ + "static/media/shopping-cart.5f8644f0.png";